import { z } from "zod";
import { EventMarketDbSchema } from "./db-schemas";
import { CompressedEventMarket } from "./types";

export function eventMarketToPick(market: z.infer<typeof EventMarketDbSchema>): CompressedEventMarket {
	return {
		id: market.id,
		title: market.title,
		event_id: market.event_id,
		participant_ids: market.market_participant_ids,
		stat_type: market.stat_type,
	};
}
